import { render } from "./SearchResults.vue?vue&type=template&id=7264ff3a&scoped=true"
import script from "./SearchResults.vue?vue&type=script&lang=js"
export * from "./SearchResults.vue?vue&type=script&lang=js"

import "./SearchResults.vue?vue&type=style&index=0&id=7264ff3a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7264ff3a"

export default script